export default __webpack_public_path__ + "/public/store_visualisation.png";